// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2F1fq","label":"Radio_label__2oASp","checkMark":"Radio_checkMark__1U77I","disabled":"Radio_disabled__3iGPt"};